import { useTranslation } from '@digitaltitransversal/cronos/i18n';
import { PluginsContext } from 'app/features/plugins/state/pluginsContext';
import { DigitalFemsaSource } from 'app/sdk/embedded/EmbeddedConfig';
import { useContext, useState } from 'react';

import { COMPONENT_CONTAINER_IDENTIFIER } from '../constants';
import { ViewState } from '../interface';

const useIframe = (state: ViewState) => {
  const { setIsFinalizedPayment } = useContext(PluginsContext);
  const { checkoutRequest, keys, isIntegration, configuration = {} } = state;
  const { i18n, t } = useTranslation();
  const [contentLoaded, setContentLoaded] = useState(false);
  const initIframe = () => {
    const buttonText = t('iFrame.checkout.buttonSubmitFinalize');
    const config = {
      targetIFrame: `${COMPONENT_CONTAINER_IDENTIFIER}`,
      checkoutRequestId: checkoutRequest.id,
      publicKey: keys.publicKey,
      isIntegration,
      locale: i18n.language,
      customStyle: configuration.customStyleJSON,
    };

    const onGetInfoSuccess = () => {
      setContentLoaded(true);
    };
    const onFinalizePayment = () => {
      setIsFinalizedPayment(true);
    };
    const callbacks: any = {
      onGetInfoSuccess,
      onFinalizePayment,
    };
    const options = buildComponentOptions(buttonText);

    window.DigitalFemsaCheckoutComponents.SelfHosted({
      config,
      isSelfHosted: true,
      preloadedState: state,
      callbacks,
      options,
      digitalFemsaSource:
        checkoutRequest.type === 'PaymentLink' ? DigitalFemsaSource.PAYMENT_LINK : DigitalFemsaSource.REDIRECTED,
    });
  };

  return {
    initIframe,
    contentLoaded,
  };
};

export default useIframe;

const buildComponentOptions = (buttonText: string) => {
  const themeConfig = {};
  return {
    ...themeConfig,
    button: {
      text: buttonText,
      buttonPayText: buttonText,
    },
  };
};
